module.exports = __webpack_public_path__ + "media/images/bannerImage9-9e7a37764de31da8ce32d9a7f8ef7cf8.jpg";